<template>
  <div>
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="90px" size="mini">
         <div class="inpBox">
              <div class="box1">
                <div style="width:280px">
                   <el-form-item label="起始地:" prop="deliverAddress  " >
                    <el-input  placeholder="" v-model="searchFrom.deliverAddress  "></el-input>
                  </el-form-item>
                  <el-form-item label="目的地:" prop="receivingAddress">
                    <el-input  placeholder="" v-model="searchFrom.receivingAddress"></el-input>
                  </el-form-item>
                </div>
                <el-form-item label="货物类型:" prop="productName "  class="hwlx">
                <el-select v-model="searchFrom.productName " multiple placeholder="请选择">
                    <el-option
                      v-for="item in goodTypes"
                      :key="item.name"
                      :label="item.name"
                      :value="item.name">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div>
                  <el-form-item label="单位:" prop="pricingMethod" >
                  <el-select v-model="searchFrom.pricingMethod"  placeholder="请选择">
                    <el-option key="1" label="吨" value="1"></el-option>
                    <el-option key="2" label="车" value="2"></el-option>
                  </el-select>
                </el-form-item>
                 <el-form-item label="颗粒度" prop="flag" >
                  <el-select v-model="searchFrom.flag"  placeholder="请选择" @change="flagChange">
                     <el-option  label="日" :value="2"></el-option>
                     <el-option  label="月" :value="1"></el-option>
                  </el-select>
                </el-form-item>
                 <el-form-item label="查询时间:" prop="createTimes" v-if="searchFrom.flag==2">
                    <el-date-picker
                      v-model="searchFrom.createTimes"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                       @change="timeChange"
                       :picker-options="pickerOptions"
                    ></el-date-picker>
                  </el-form-item>
                   <el-form-item label="查询时间:" prop="createTimes" v-if="searchFrom.flag==1">
                    <el-date-picker
                      v-model="searchFrom.createTimes"
                      format="yyyy-MM"
                      value-format="yyyy-MM"
                      type="monthrange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      @change="timeChange"
                      :picker-options="pickerOptions"
                    ></el-date-picker>
                  </el-form-item>
              </div>
        </div>
        <div class="searchBtnBox">
              <el-form-item>
                  <el-button type="primary" @click="searchFn">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary"  @click="resetForm('searchFrom')">重置</el-button>
                </el-form-item>
            </div>
      </el-form>
    </div>
     <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"
        style="width: 100%" height="100%"  center border v-if="!loading" >
       <el-table-column  fixed type="index" prop="date"  width="55" label="序号"></el-table-column>
         <el-table-column property="deliverProvinceName " label="起始地"  fixed width="200">
          <template scope="scope">
           <div>
              <div v-if="scope.row.deliverProvinceName">{{scope.row.deliverProvinceName}}-{{scope.row.deliverCityName}}-{{scope.row.deliverAreaName}}</div>
              <div v-else>-</div>
           </div>
          </template>
        </el-table-column>
        <el-table-column property="deliverProvinceName " label="目的地" fixed  width="200" >
          <template scope="scope">
           <div>
              <div v-if="scope.row.receivingProvinceName">{{scope.row.receivingProvinceName}}-{{scope.row.receivingCityName}}-{{scope.row.receivingAreaName}}</div>
              <div v-else>-</div>
           </div>
          </template>
        </el-table-column>
        <el-table-column  fixed property="productName"  width="100" label="货物类型"></el-table-column>
        <el-table-column label="车次数量（单车重量）">
          <el-table-column   property="tenLess"  width="100" label="10吨以下"></el-table-column>
          <el-table-column   property="tenToTwenty"  width="100" label="10-20吨"></el-table-column>
          <el-table-column   property="twentyToThirty"  width="100" label="20-30吨"></el-table-column>
          <el-table-column   property="moreThirty"  width="100" label="30吨以上"></el-table-column>
        </el-table-column>
        <el-table-column property="trainNum" width="120" :formatter="emptyFn" label="总车次"></el-table-column>
        <el-table-column property="pricingMethod " label="单位" >
          <template scope="scope">
            <div>
              <div v-if="scope.row.pricingMethod"> {{[ "吨", "车" ][scope.row.pricingMethod -1]}}</div>
              <div v-else>-</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="成交价格（元）">
          <el-table-column   property="minPrice"  width="100" label="最低"></el-table-column>
          <el-table-column   property="maxPrice"  width="100" label="最高"></el-table-column>
          <el-table-column   property="avgPrice"  width="100" label="平均"></el-table-column>
        </el-table-column>
        <el-table-column property="price" width="120" :formatter="emptyFn"  label="发生费用（元）"></el-table-column>
        <el-table-column property="weight" width="130" :formatter="emptyFn"  label="总运量（吨)"></el-table-column>
        <!-- <el-table-column v-for="item in tableArr" :key="item" :property="item"  :width="tableArr.length==1?150:100" :label="item"></el-table-column> -->
         <el-table-column :label="searchFrom.flag==1?'月运量（吨）':'日运量（吨）'"  v-if="tableArr.length>0">
          <el-table-column v-for="item in tableArr" :key="item" :property="item"  :width="tableArr.length==1?150:100" :label="item"></el-table-column>
        </el-table-column>
        </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
 </div>
</template>

<script>
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
import { dropDownList } from '@/api/soc-stock'
import { transportationInfo } from '@/api/soc-customer'
export default {
  data () {
    return {
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      emptyFn: emptyFn,
      tableArr: [],
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50,
        flag: 2
      },
      total: 0,
      goodTypes: [],
      loading: false,
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e7
        }
      }
    }
  },
  created () {
    dropDownList().then(res => {
      this.goodTypes = res
    })
    this.getTimeFn('createTimes')
    this.searchFn()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 98) + 'px'
  },
  methods: {
    // 颗粒度切换
    flagChange () {
      this.$set(this.searchFrom, 'createTimes', null)
    },
    // 选择时间区间
    timeChange () {
      let star = new Date(this.searchFrom.createTimes[0]).getTime()
      let end = new Date(this.searchFrom.createTimes[1]).getTime()
      if (this.searchFrom.flag == 2) {
        if (end - star > 3600 * 1000 * 24 * 32) {
          this.$alert('选择得时间区间请少于32天', '系统提示')
          this.$set(this.searchFrom, 'createTimes', null)
        }
      } else {
        if (end - star > 3600 * 1000 * 24 * 30 * 13) {
          this.$alert('选择得时间区间请少于13个月', '系统提示')
          this.$set(this.searchFrom, 'createTimes', null)
        }
      }
    },
    // 设置默认时间
    getTimeFn (name) {
      const that = this
      let end = new Date()
      end.setTime(end.getTime() - 3600 * 1000 * 24 * 1)
      const end1 = this.dateFormat(1, 2, end)
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
      let start1 = this.dateFormat(1, 2, start)
      that.$set(that.searchFrom, name, [start1, end1])
    },
    searchFn () {
      if (this.searchFrom.createTimes) {
        this.getList()
      } else {
        this.$alert('请选择查询时间', '系统提示')
      }
    },
    // 选择数据

    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList () {
      this.loading = true
      const loading = this.$loading({
        lock: true,
        text: '正在查询...'
      })
      transportationInfo(this.searchFrom).then(res => {
        loading.close()
        this.loading = false
        let arr = res.list
        this.tableArr = []
        arr.forEach((item, index) => {
          item.weightByGroup.forEach((data) => {
            if (this.searchFrom.flag == 2) {
              if (index == 0) {
                this.tableArr.push(data.createTime + '日')
              }
              item[data.createTime + '日'] = data.weight
            } else {
              if (index == 0) {
                this.tableArr.push(data.createTime + '月')
              }

              item[data.createTime + '月'] = data.weight
            }
          })
          delete item.weightByGroup
        })
        console.log(arr)
        console.log(this.tableArr)
        this.tableList = arr
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList()
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList()
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        flag: 2
      }
      this.getTimeFn('createTimes')
    },

    closeDialog () {
      this.addFrom = {}
      this.$refs.table.clearSelection()
      this.$refs.addFrom.clearValidate()
      this.flag = false
    }
  }
}
</script>

<style scoped lang='less'>
.inpBox{
  display: flex;
  .box1{
    display: flex;
    flex-shrink: 0;
  }
}
.searchBox .el-date-editor{
      width: 260px!important;
}

.hwlx{
    /deep/.el-input__inner{
            height: 65px!important;
            width: 300px;
          }
    /deep/.el-select {
      width: 300px;
    }
}

</style>
